var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNativeAppsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 4c0-.82.656-1.5 1.5-1.5h5.25c.82 0 1.5.68 1.5 1.5v9c0 .844-.68 1.5-1.5 1.5h-5.25a1.48 1.48 0 0 1-1.5-1.5V4zm4.875 9a.771.771 0 0 0-.75-.75.755.755 0 0 0-.75.75c0 .422.328.75.75.75.398 0 .75-.328.75-.75zm1.875-9h-5.25v7.5h5.25V4z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNativeAppsGrey);
export default __webpack_public_path__ + "static/media/native_apps_grey.e369bae014c856aa1ddbbeca4912c85d.svg";
export { ForwardRef as ReactComponent };